/** Query keys the master mapping table and its side panel share (ADR 0078). */
export const CLIENTS_KEY = ["clients"];
export const SCREENCONNECT_KEY = ["screenconnect-companies"];
export const DATTO_SITES_KEY = ["datto-sites"];
/** Mappings → Techs: its summary rows and the panel each opens share it. */
export const TECH_MAPPING_KEY = ["tech-mapping"];
